import React, { useEffect, useState } from "react";

//* import css
import cssClasses from "./QueuePage.module.css";

//* imports MUI
import { Box, Typography,Modal } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CropFreeIcon from "@mui/icons-material/CropFree";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ViewMore from "../../Assets/Images/Common/viewMoreIcon.svg";
import eventIcon from "../../Assets/Images/Common/Browser.svg";
//* import subComponents
import Button from "../../Subcomponents/Button";
import Search from "../../Subcomponents/Search";
import StatusChip from "../../Subcomponents/LeadStatusChip";
import PlaceIcon from "@mui/icons-material/Place";
import Calendar from "../../Assets/Images/Common/calendar.svg";
import { Card } from "@mui/material";
//* import store
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import { dismissLoader, presentLoader } from "../../Services/loader";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { getAllEvents, getLiveAllEvents } from "../../Services/AssignNewToken";
import * as _ from "lodash";
import { useNavigate } from "react-router-dom";
import EmptyListIcon from "../../Assets/Images/Common/NoSiteVisitsFound.svg";
import { offlineToast,errorTost } from "../../Services/Toast";
import { Network } from "@capacitor/network";
import { useSelector } from "react-redux";

import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import { getLaunches } from "../../Services/FastBooking";
import Close from '../../Components/Icons/Close';

function QueuePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [eventsPresent, setEventsPresent] = useState(null);
  const [events, setEvents] = useState([]);

  const [eventData, setEventData] = useState('');
  const [launchList, setLaunchList] = useState([]);
  const [allLaunches, setAllLaunches] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState('');
  let [selectedLaunchArr, setSelectedLaunchArr] = useState([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [launchFormat, setLaunchFormat] = useState('Single');
  const style = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20%',
    height : '100',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
  };

  const handleClose = () => {
    setOpen(false);
    setLaunchFormat('Single');
  };


  useEffect(() => {
    dispatch(action.activeMenu("queue"));
    getEvents();
  }, []);
  function getEvents() {
    presentLoader();
    Network.getStatus().then((status) => {
      if (status.connected) {
    getAllEvents()
      .then((resp) => {
        console.log(resp);
        resp.data = resp.data.map((el, index) => ({
          ...el,
          index: index,
          id: el.eventId,
          eventtitle: el.title,
        }));
        console.log("events: ", resp);
        setEvents([...resp.data]);
        setEventsPresent(resp.data.length > 0 ? true : false);
        dismissLoader();
      })
      .catch((err) => {});
    }else{
      offlineToast();
    }});
  }

  
  async function getAllLaunches(eventId) {
    await getLaunches(eventId)
      .then((resp) => {
        resp.data = resp.data.map((each) => ({
          ...each,
          label: each.title,
          value: each.launchId,
        }));
        setAllLaunches([...resp.data]);
        setLaunchList([...resp.data]);
        setSelectedLaunch(resp.data[0].launchId);
        setSelectedLaunchArr([resp.data[0].launchId]);
      })
      .catch((err) => {
        errorTost(err.message)
      });
  }

  const handleModal=(eventId)=>{
    getAllLaunches(eventId);
    setEventData(eventId);
    handleOpen();
  }

  return (
    <>
      <div className={cssClasses.wrapperPage}>
        <Box className={cssClasses.headerWrapper}>
          <Box className={cssClasses.headerLeftSide}>
            <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
              <Typography className={cssClasses.headerTittle}>Queue</Typography>
            </Box>
          </Box>
        </Box>

        <div className={cssClasses.mainWrapper}>
          {/* Events */}

          {eventsPresent && (
            <div className={cssClasses.eventsWrapper}>
              {events.map((event) => (
                <Card className={cssClasses.eventWrap}>
                  <div className={cssClasses.eventInfo}>
                    <div className={cssClasses.eventImg}>
                      {event && event.bannerImgUrl ? (
                        <img
                          src={
                            process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                            event.bannerImgUrl
                          }
                          alt="Event"
                        />
                      ) : (
                        <div
                          style={{
                            background: "#FDB022",
                            borderRadius: "50%",
                            textAlign: "center",
                          }}
                        >
                          <img
                            style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                            src={eventIcon}
                            alt=""
                          />
                        </div>
                        // <img src={EventDefaultImg} alt="Event" />
                      )}
                    </div>
                    <div className={cssClasses.eventData}>
                {/* ??Since we are only getting live events so only one status chip will be there */}
                       {event.startDateTime<Date.now()&&event.endDateTime>Date.now()&&(
                           <LeadStatusChip
                           label={'Live event'}
                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                           style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                         ></LeadStatusChip>
                      )}
                      <div className={cssClasses.eventName}>
                        {event.eventtitle}
                      </div>
                      <div className={cssClasses.eventLaunches}>
                        {/* {event.launch.map((launch, index) => (
                        <div className={cssClasses.launchWrap}>
                          <div className={cssClasses.launchIcon}>
                          </div>
                          <div className={cssClasses.launchLoc}>
                            {launch.launchtitle}, {launch.addressline2}
                          </div>

                        </div>
                      ))} */}
                      </div>
                      <div className={cssClasses.eventDate}>
                        <div className={cssClasses.launchIcon}>
                          <img src={Calendar} alt="Event Schedule" />
                        </div>
                        <div className={cssClasses.launchLoc}>
                          From{" "}
                          <span className={cssClasses.bold}>
                            {new Date(event.startDateTime).toDateString()},{" "}
                            {new Date(event.startDateTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>{" "}
                          to{" "}
                          <span className={cssClasses.bold}>
                            {new Date(event.endDateTime).toDateString()},{" "}
                            {new Date(event.endDateTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </div>
                      </div>
                      
                        {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.isAccessible && (
                          <div className={cssClasses.viewMore}>
                           <img
                           src={ViewMore}
                           style={{ cursor: "pointer" }}
                           alt={"More"}
                           onClick={() => {
                            //  navigate(`/home/Queue/${event.eventId}`);
                           handleModal(event.eventId)
                            
                           }}
                         />
                          </div>
                        )}
                       
                     
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
               {eventsPresent===false&&(
              <div className={cssClasses.noDataMsg}>
              <div className={cssClasses.emptyIcon}>
                <img src={EmptyListIcon} alt="No Live Events" />
              </div>
              <div className={cssClasses.emptyTitle}>No Live Events Found</div>
            
            </div>
          )}
           <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== 'backdropClick') {
                handleClose();
              }
            }}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
          >
           <Box sx={style}>
              <Box className={cssClasses.headerDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.flexCol}>
                    <Box className={cssClasses.flexRow}>
                      <Box className={cssClasses.HeaderTitle}>Event Info:</Box>{' '}
                    </Box>
                    <Box className={cssClasses.bhkTitle}></Box>
                  </Box>
                  <Box
                    ml={'auto'}
                    mt={1}
                    onClick={handleClose}
                    style={{ cursor: 'pointer' }}
                  >
                    <Close width={'1.2rem'} height={'1.2rem'} />
                  </Box>
                </Box>
              </Box>

              <Box width={'100%'} height={'85%'} overflow={'auto'}>
                <Box margin={'1.5rem 3.2rem'}>
                  <Box className={cssClasses.ThirdDiv}>
                   <Box className={cssClasses.ThirdDiv}>
                      <Box className={cssClasses.InputTitle} mt={1.5}>
                        Select Launch Format :{' '}
                      </Box>
                      <Box className={cssClasses.widthBox}>
                        <CustomRadio
                          optionList={['Single', 'Multiple']}
                          value={launchFormat}
                          onChangeValue={(e) => {
                            setLaunchFormat(e);
                            sessionStorage.setItem('launchFormat', e);
                            if (e === 'Multiple') {
                              setSelectedLaunch('All');
                            }
                          }}
                        />
                      </Box>
                      <Box className={cssClasses.InputTitle}>
                        Select Launch :{' '}
                      </Box>
                      <Box className={cssClasses.widthBox}>
                        {launchFormat === 'Single' ? (
                          <DropDown
                            list={allLaunches}
                            selectedValue={selectedLaunch}
                            onChangeSelect={(_value) => {
                              setSelectedLaunch(_value);
                            }}
                            helperText=''
                            style={{
                              background: '#F2F4F7',
                              color: 'rgb(102, 112, 133)',
                            }}
                            placeHolder='Select Launch'
                          ></DropDown>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                              gap: '1rem',
                              marginTop: '1rem',
                              marginBottom : '1rem',
                              maxHeight : '12rem',
                              overflow : 'auto'
                            }}
                          >
                            {launchList.map((launch) => (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  flexDirection: 'row',
                                  gap: '1rem',
                                }}
                              >
                                <input
                                  className={cssClasses.checkbox}
                                  type='checkbox'
                                  name=''
                                  id={launch?.launchId}
                                  style={{ cursor: 'pointer' }}
                                  onChange={(e) => {
                                    if (
                                      selectedLaunchArr.includes(
                                        launch?.launchId
                                      )
                                    ) {
                                      setSelectedLaunchArr(
                                        (prevSelectedLaunchArr) =>
                                          prevSelectedLaunchArr.filter(
                                            (id) => id !== launch?.launchId
                                          )
                                      );
                                    } else {
                                      setSelectedLaunchArr(
                                        (prevSelectedLaunchArr) => [
                                          ...prevSelectedLaunchArr,
                                          launch?.launchId,
                                        ]
                                      );
                                    }
                                  }}
                                  checked={
                                    selectedLaunchArr?.includes(
                                      launch?.launchId
                                    )
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  htmlFor={launch?.launchId}
                                  className={cssClasses.toggleLabel}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {launch?.title}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </Box>
                    </Box>
                    
                    
                  </Box>
                </Box>
              </Box>

              <Box className={cssClasses.FooterDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box width={'fit-Content'} ml={'auto'}>
                    <Button
                      style={{
                        fontSize: '1.6rem',
                        lineHeight: '2.4rem',
                        color: '#344054',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '0.4rem',
                      }}
                      padding={'0.6rem 2rem'}
                      btnName={'Cancel'}
                      clicked={handleClose}
                    />
                  </Box>

                  <Box width={'fit-Content'}>
                    <Button
                      style={{
                        fontSize: '1.6rem',
                        lineHeight: '2.4rem',
                        color: '#FFF',
                        backgroundColor: '#007FFF',
                        borderRadius: '0.4rem',
                      }}
                      padding={'0.6rem 2rem'}
                      btnName={'Go'}
                     clicked={() => {
                          sessionStorage.setItem(
                            'selectedLaunchesForQueue',
                            JSON.stringify(selectedLaunchArr)
                          );
                          navigate(
                            `/home/queue/${eventData}/${selectedLaunch}`
                          );
                        
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default QueuePage;
